// Organisation logos in small places (the "Choose an organisation" list): always inside a fixed 40 × 40 tile with
// rounded corners; the picture is fitted inside it (never cropped, never larger than the tile). The organisation's
// initials sit underneath, so if the logo can't be loaded, or is an odd shape (very wide or very tall, or has no size
// at all), the picture is taken away and the initials show instead.
// The same check also covers the logo at the top of the side menu: a broken one is replaced by the initial.
import { esc } from "./lib.js";
import { orgInitials, usableLogo } from "../../shared/orglogo.js";

export { orgInitials, usableLogo };

/** The 40 × 40 tile: the logo (if any) over the organisation's initials. */
export function orgTileHtml(name: string, logoUrl?: string | null): string {
  return `<span class="falcon-org-initials falcon-org-tile${logoUrl ? " has-logo" : ""}"><span class="falcon-org-tile-letters" aria-hidden="true">${esc(orgInitials(name))}</span>${logoUrl ? `<img class="falcon-org-tile-img" src="${esc(logoUrl)}" alt="">` : ""}</span>`;
}

function giveUp(img: HTMLImageElement): void {
  const tile = img.closest(".falcon-org-tile");
  if (tile) { tile.classList.remove("has-logo"); img.remove(); return; }
  const frame = img.closest(".sidebar-organisation-logo-frame");
  if (frame) {
    const name = frame.closest("#platform-brand")?.querySelector(".sidebar-organisation-name")?.textContent || img.alt.replace(/ logo$/, "");
    frame.innerHTML = `<span class="sidebar-organisation-initials" title="${esc(name)}">${esc(orgInitials(name).slice(0, 1))}</span>`;
    frame.classList.add("logo-failed");
  }
}
function check(img: HTMLImageElement): void {
  if (img.closest(".falcon-org-tile") && !usableLogo(img.naturalWidth, img.naturalHeight)) giveUp(img);
}
const isOrgLogo = (t: EventTarget | null): t is HTMLImageElement =>
  t instanceof HTMLImageElement && (t.classList.contains("falcon-org-tile-img") || (t.classList.contains("sidebar-organisation-logo") && !!t.closest("#platform-brand")));

// Images don't pass "error" and "load" up the page, but a listener on the whole document still sees them first.
document.addEventListener("error", (e) => { if (isOrgLogo(e.target)) giveUp(e.target); }, true);
document.addEventListener("load", (e) => { if (isOrgLogo(e.target)) check(e.target); }, true);
/** For logos that finished (or failed) before the listener could see them, e.g. from the browser's cache. */
export function checkOrgLogos(root: ParentNode = document): void {
  root.querySelectorAll<HTMLImageElement>("img.falcon-org-tile-img, #platform-brand img.sidebar-organisation-logo").forEach((img) => {
    if (!img.complete) return;
    if (img.naturalWidth === 0 && img.naturalHeight === 0) giveUp(img); else check(img);
  });
}
